//  <copyright>
//  Copyright (c) Microsoft Corporation. All rights reserved.
//  </copyright>

import * as React from 'react';
export const Book = () => {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.5 4C4.5 2.89543 5.39543 2 6.5 2H14.5C15.6046 2 16.5 2.89543 16.5 4V15C16.5 15.5523 16.0523 16 15.5 16H5.5C5.5 16.5523 5.94772 17 6.5 17H16C16.2761 17 16.5 17.2239 16.5 17.5C16.5 17.7761 16.2761 18 16 18H6.5C5.39543 18 4.5 17.1046 4.5 16V4ZM7.25 4C6.83579 4 6.5 4.33579 6.5 4.75V5.25C6.5 5.66421 6.83579 6 7.25 6H13.75C14.1642 6 14.5 5.66421 14.5 5.25V4.75C14.5 4.33579 14.1642 4 13.75 4H7.25Z"
        fill="#464FEB"
      />
    </svg>
  );
};
